<template>
	<q-dialog :maximized="isMobile" persistent v-model="show_drill">
		<q-card :style="sizeCard">
			<q-toolbar>
				<q-toolbar-title></q-toolbar-title>
				<q-btn flat round dense @click="hideModal()" icon="fas fa-times" />
			</q-toolbar>

			<q-card-section :class="isMobile ? 'q-pa-md q-pt-none' : 'q-px-xl q-pt-none'">
				<div class="row">
					<q-toolbar-title class="q-mb-md"> {{ drill_title }} </q-toolbar-title>

					<div class="bg-yellow-2 q-pa-md full-width rounded-borders q-mb-xl">
						<span class="text-weight-bold text-subtitle1 q-mr-xs"
							>{{ $t('challenge_of_the_day') }}:</span
						>
						<span class="text-subtitle1 text-weight-light q-mr-md">
							{{ $t('recall_and_test_your_knowledge_with') }} {{ qty_questions_frequency }}
							{{
								qty_questions_frequency === 1 ? $t('quick_question') : $t('quick_questions')
							}}</span
						>
					</div>

					<!-- <div class="col-12 text-uppercase text-body2">
						{{ $t('question') }} {{ qty_drill_total_questions - drill_qty_questions + 1 }}
						{{ $t('of') }} {{ qty_drill_total_questions }}
						<q-linear-progress rounded size="6px" color="primary" :value="progress" />
					</div> -->
				</div>

				<div class="row">
					<div class="col-12 q-mt-xl">
						<span
							class="text-weight-bold"
							:class="
								response === ''
									? ''
									: show_feedback &&
									  response.data.last_question_correct !== null &&
									  response.data.last_question_correct === false &&
									  response.data.previous_question_correct_answer.id != drill_question_answer
									? 'text-negative'
									: 'text-positive'
							"
							v-html="title"
						></span>

						<q-option-group
							v-if="!show_feedback"
							type="radio"
							v-model="drill_question_answer"
							:options="
								drill_question_answers.map((s) => {
									return { value: s.id, label: s.title }
								})
							"
							@input="v$.drill_question_answer.$touch"
						>
							<template v-slot:label="opt">
								<div class="row items-center">
									<span class="text-black">{{ opt.label }}</span>
								</div>
							</template>
						</q-option-group>

						<q-option-group
							v-if="show_feedback"
							type="radio"
							disable
							v-model="drill_question_answer"
							:options="
								drill_question_answers.map((s) => {
									return { value: s.id, label: s.title }
								})
							"
						>
							<template v-slot:label="opt">
								<div class="row items-center">
									<span
										:class="
											response.data.last_question_correct !== null &&
											response.data.previous_question_correct_answer.id != opt.value
												? 'text-negative'
												: 'text-positive'
										"
										>{{ opt.label }}</span
									>
								</div>
							</template>
						</q-option-group>
					</div>
				</div>
				<div class="row justify-end q-mt-lg">
					<div class="col-xs-12 col-sm-2" v-if="response === ''">
						<q-btn
							rounded
							color="primary"
							class="full-width"
							:label="$t('send')"
							@click="sendDrill()"
						/>
					</div>
					<div class="col-xs-12 col-sm-2" v-if="response !== ''">
						<q-btn
							rounded
							color="primary"
							class="full-width"
							:label="response !== '' && response.data.id ? $t('next_question') : $t('finish')"
							@click="nextOrFinishDrills()"
						/>
					</div>
				</div>
			</q-card-section>
		</q-card>
	</q-dialog>
</template>

<script>
import { required } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'

export default {
	name: 'OptionalDrill',

	props: ['show', 'drill_id'],

	setup() {
		return { v$: useVuelidate({ $scope: false }) }
	},

	data() {
		return {
			drill_question_id: '',
			drill_title: '',
			drill_description: '',
			title: '',
			response: '',
			drill_question_answers: [],
			drill_question_answer: null,
			show_feedback: false,
			progress: 0,
			drill_qty_questions: 0,
			qty_drill_total_questions: 0,
			qty_questions_frequency: 0,
		}
	},

	computed: {
		show_drill: {
			get() {
				return this.show
			},
			set() {
				this.$emit('hide_drill')
			},
		},

		isMobile() {
			return this.$q.platform.is.mobile
		},

		sizeCard() {
			return {
				minWidth: this.isMobile ? '100vw' : '55vw',
				height: this.isMobile ? '100vh' : '65vh ',
			}
		},
	},

	methods: {
		fetchDrill() {
			this.$q.loading.show()

			this.$axios
				.get(`/etraining_drills/drills/${this.drill_id}/`)
				.then((response) => {
					this.populatedrill(response.data)
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		sendDrill() {
			this.v$.$touch()

			if (!this.v$.$error) {
				this.$q.loading.show()
				let data = {
					answer: this.drill_question_answer,
					drill_question_id: this.drill_question_id,
				}

				this.$axios
					.post(`/etraining_drills/drills/${this.drill_id}/submit_answer/`, data)
					.then((response) => {
						this.response = response
						if (response.data.show_feedback) {
							this.$q.notify({
								message: this.$t(
									response.data.last_question_correct ? 'correct_answer' : 'incorrect_answer'
								),
								type: response.data.last_question_correct ? 'positive' : 'negative',
								icon: response.data.last_question_correct
									? 'fal fa-check-circle'
									: 'fal fa-times-circle',
							})
						} else {
							this.$q.notify({
								message: this.$t('save_data_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})
						}
						if (!response.data.show_feedback) this.nextOrFinishDrills()
						else this.show_feedback = true
					})
					.catch((e) => {
						console.log(e)
						this.$q.notify({
							message: this.$t('an_unexpected_error_has_occurred_try_again'),
							type: 'negative',
							icon: 'fal fa-exclamation-triangle',
							position: 'top',
						})
						this.clearDrillAnswers()
						this.hideModal()
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		nextOrFinishDrills() {
			if (this.response.data.id) {
				this.clearDrillAnswers(this.response.data)
			} else {
				this.hideModal()
				this.clearDrillAnswers()
			}
		},

		populatedrill(data) {
			this.drill_question_id = data.id
			this.drill_title = data.drill_title
			this.drill_description = data.drill_description
			this.title = data.title
			this.drill_qty_questions = data.drill_qty_questions
			this.qty_drill_total_questions = data.qty_drill_total_questions
			this.qty_questions_frequency = data.qty_questions_frequency
			this.progress =
				(data.qty_drill_total_questions - data.drill_qty_questions) / data.qty_drill_total_questions
			this.drill_question_answers = data.drill_question_answers
		},

		clearDrillAnswers(data) {
			this.v$.$reset()
			this.drill_question_id = ''
			this.drill_title = ''
			this.drill_description = ''
			this.title = ''
			this.response = ''
			this.drill_question_answers = []
			this.drill_question_answer = null
			this.show_feedback = false
			if (data) this.populatedrill(data)
		},

		hideModal() {
			this.clearDrillAnswers()
			this.$emit('hide_drill')
		},

		description(e) {
			var regex = /(<([^>]+)>)/gi
			var body = '<p>test</p>'
			var result = body.replace(regex, '')
			if (e) return e.replace(regex, '')
		},
	},

	watch: {
		show_drill: function () {
			if (this.show_drill) {
				this.fetchDrill()
			}
		},
	},

	created() {
		if (this.show_drill) this.fetchDrill()
	},

	validations() {
		return {
			drill_question_answer: {
				required,
			},
		}
	},
}
</script>

<style></style>
